import {_} from 'lodash';
import {IRulesetVariableCrud, viewModel as RulesetVariableCrudViewModel} from '../../../ruleset/variable/crud'

export {template} from '../../../ruleset/variable/crud'

export class viewModel extends RulesetVariableCrudViewModel {

    constructor(params: IRulesetVariableCrud) {
        super(_.defaultsDeep(params, {
            operations: [
                'preview',
                'update',
                'read',
                'pick',
                'create',
                'remove',
            ],
        }));
    }

}